import React from 'react';
import type { IconBaseProps } from 'react-icons';
import { FaHandshake as FaHandshakeSrc } from 'react-icons/fa';
import {
  FaCloud as FaCloudSrc,
  FaList as FaListSrc,
  FaSeedling as FaSeedlingSrc,
} from 'react-icons/fa6';

function wrapIcon(Icon: React.ComponentType<IconBaseProps>) {
  return (props: IconBaseProps) => React.createElement(Icon, props);
}

export const FaHandshake = wrapIcon(FaHandshakeSrc as React.ComponentType<IconBaseProps>);
export const FaCloud = wrapIcon(FaCloudSrc as React.ComponentType<IconBaseProps>);
export const FaList = wrapIcon(FaListSrc as React.ComponentType<IconBaseProps>);
export const FaSeedling = wrapIcon(FaSeedlingSrc as React.ComponentType<IconBaseProps>);
